(function (global, $, Si) {
    "use strict";

    Si.when('Ajax/Player', 'Templates').then(playerStatModalComponent);

    function playerStatModalComponent(Player, Templates) {

        Si.component('PlayerStatModal', {
            initPlayerStatModal: initPlayerStatModal
        });

        var params = {
                player_id: '',
                season: '',
                tour_id: '',
                current_page_tour_id: '',
                team_id: '',
                partial: 0
            },
            VIEW_MODAL = 'modal',
            VIEW_STAT_TABLE = 'player_statistics_table',
            VIEW_PLAYER_TEAMS = 'player_teams',
            $popupLoaderSelector = '.popup-loader',
            $loader = $('[data-loader]');

        function initPlayerStatModal(modalSelector, modalLinkSelector, seasonLinkSelector, teamLinkSelector, statTableSelector) {
            $(modalLinkSelector).on('click', playerClickHandler);

            function playerClickHandler(e) {
                e.preventDefault();
                $(modalSelector).remove();
                $loader.addClass('visible');
                fillLoadParams(e.target, 0);
                loadData();
            }

            function seasonClickHandler(e) {
                e.preventDefault();
                $(seasonLinkSelector).removeClass('active');
                $(e.target).addClass('active');
                $(modalSelector).find($popupLoaderSelector).addClass('visible');
                fillLoadParams(e.target, 1);
                loadData();
            }

            function teamClickHandler(e) {
                e.preventDefault();
                $(teamLinkSelector).removeClass('active');
                $(e.target).addClass('active');
                $(modalSelector).find($popupLoaderSelector).addClass('visible');
                fillLoadParams(e.currentTarget, 1);
                loadData();
            }

            function fillLoadParams(element, season_only) {
                params.player_id = $(element).data('player-id');
                params.season = $(element).data('season');
                params.tour_id = $(element).data('tour-id');
                params.team_id = $(element).data('team-id');
                params.season_only = season_only;
                params.current_page_tour_id = $(modalSelector).data('current-page-tour-id');
            }

            function renderView(view, response) {
                var content = Templates.make('player/' + view + '.mustache', response);
                var stat_table = Templates.make('player/' + VIEW_STAT_TABLE + '.mustache', response);
                var player_teams_content = Templates.make('player/' + VIEW_PLAYER_TEAMS + '.mustache', response);
                $('body').append(content);
                $(modalSelector).find(statTableSelector).html(stat_table);
                $(modalSelector).find('[data-teams]').html(player_teams_content);
                $(modalSelector).on('click', seasonLinkSelector, seasonClickHandler);
                $(modalSelector).on('click', teamLinkSelector, teamClickHandler);
                $loader.removeClass('visible');
                $(modalSelector).modal('show');
            }

            function renderPartial(response) {
                var content = Templates.make('player/' + VIEW_STAT_TABLE + '.mustache', response);
                $(modalSelector).find(statTableSelector).html(content);
                if(typeof response.teams != 'undefined'){
                    var teamsContent = Templates.make('player/' + VIEW_PLAYER_TEAMS + '.mustache', response);
                    $(modalSelector).find('[data-teams]').html(teamsContent);
                }
                if(typeof response.tournament_name != 'undefined'){
                    $(modalSelector).find('[data-tournament]').text(response.tournament_name);
                }
                if(typeof response.team_id != 'undefined') {
                    $(modalSelector).find(seasonLinkSelector).attr('data-team-id', response.team_id);
                }

                $(modalSelector).find($popupLoaderSelector).removeClass('visible');
            }

            function loadData() {
                return Player.get(params).then(
                    function (response) {
                        if (params.season_only == 0) {
                            renderView(VIEW_MODAL, response);
                        } else {
                            renderPartial(response);
                        }

                    }, function (status, error) {
                        console.log(status, error);
                        alert('Error appear while data loading...');
                        $loader.removeClass('visible');
                    }
                );
            }
        }
    }
})(window, jQuery, Si);